"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_konva_utils_1 = require("react-konva-utils");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var GanntListItemToggling = function (_a) {
    var x = _a.x, y = _a.y, icon = _a.icon, width = _a.width, height = _a.height, onClick = _a.onClick, color = _a.color;
    return ((0, jsx_runtime_1.jsx)(react_konva_utils_1.Html, { children: (0, jsx_runtime_1.jsx)("button", __assign({ className: "absolute flex items-center justify-center", style: {
                width: width,
                height: height,
                top: y,
                left: x,
            }, onClick: onClick }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: icon, size: "sm", color: color }, void 0) }), void 0) }, void 0));
};
exports.default = GanntListItemToggling;
